import { render } from '@testing-library/react';
import React from 'react';

import Success from './Success';

describe('Success', () => {
  const renderSuccess = (props) => render(<Success {...props} />);

  it('renders the component', () => {
    const { container } = renderSuccess({ email: 'email@email.com' });
    expect(container).toMatchSnapshot();
  });
});
